import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** QR encoding of an `otpauth://` URI for authenticator apps. */
export function TotpQrCode({ uri }: { uri: string }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(uri, { errorCorrectionLevel: 'M', margin: 1, width: 140 })
      .then((url) => {
        if (!cancelled) setSrc(url);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [uri]);

  if (!src) return null;

  return (
    <img
      className="totp-qr"
      src={src}
      alt="Scan with your authenticator app"
      width={140}
      height={140}
    />
  );
}
